<template>
	<div class="card-header">
		<!-- <h6 class="card-title">{{title}}</h6> -->
		<slot></slot>
	</div>
</template>

<script>

export default {
	props: {
        title: {
            type: String,
            default: ""
        }
    },
}

</script>